import { Link } from 'react-router-dom';
import './Legal.css';

function PrivacyPro() {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header-content">
          <Link to="/" className="back-button">
            <span className="back-arrow">←</span>
            Retour
          </Link>
        </div>
      </header>

      <main className="legal-content">
        <h1 className="legal-title">Politique de Confidentialité Pro</h1>
        <p className="legal-update">Dernière mise à jour : Décembre 2024</p>

        <div className="legal-tabs">
          <Link to="/privacy" className="legal-tab">Clients</Link>
          <Link to="/privacy-pro" className="legal-tab active">Chauffeurs Pro</Link>
        </div>

        <p className="legal-intro">
          En tant que Chauffeur Partenaire RideLuv, la protection de vos données personnelles et professionnelles est essentielle. Cette politique explique quelles données nous collectons dans le cadre de votre activité professionnelle, conformément au RGPD.
        </p>

        <section className="legal-section">
          <h2 className="legal-section-title">1. Responsable du traitement</h2>
          <p className="legal-section-text">
            RideLuv SAS est responsable du traitement de vos données personnelles et professionnelles. Pour toute question, contactez notre Délégué à la Protection des Données à dpo@rideluv.com ou par courrier à notre siège social.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">2. Données collectées</h2>
          <p className="legal-section-text">
            Dans le cadre de votre activité de Chauffeur Partenaire, nous collectons : vos données d'identité (nom, prénom, photo, email, téléphone), vos documents professionnels (carte VTC, permis de conduire, carte grise, attestation d'assurance, extrait Kbis), vos données bancaires pour le versement de vos revenus, vos données de géolocalisation pendant les heures d'activité, vos statistiques d'activité (courses effectuées, évaluations, temps de connexion), et les données techniques de l'appareil utilisé.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">3. Finalités du traitement</h2>
          <p className="legal-section-text">
            Vos données sont utilisées pour : vérifier votre éligibilité au statut de Chauffeur Partenaire, vous attribuer des courses en fonction de votre position, calculer et verser vos revenus, assurer la sécurité des passagers et la qualité du service, respecter nos obligations légales et réglementaires, améliorer nos services et l'expérience utilisateur, et prévenir la fraude.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">4. Géolocalisation</h2>
          <p className="legal-section-text">
            La géolocalisation est essentielle au fonctionnement du service. Elle est utilisée pour : vous proposer des courses à proximité, permettre aux passagers de suivre l'arrivée de leur chauffeur, calculer le trajet et le prix de la course, assurer la sécurité en cas d'incident. La géolocalisation est active uniquement lorsque vous êtes connecté à l'Application Pro. Vous pouvez vous déconnecter à tout moment pour interrompre la collecte.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">5. Base légale</h2>
          <p className="legal-section-text">
            Le traitement de vos données repose sur : l'exécution du contrat de partenariat, notre intérêt légitime (sécurité, amélioration du service), le respect d'obligations légales (documents professionnels, facturation), et votre consentement pour certains traitements spécifiques. Vous pouvez retirer votre consentement pour les traitements non essentiels.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">6. Partage des données</h2>
          <p className="legal-section-text">
            Vos données peuvent être partagées avec : les passagers (prénom, photo, note, position du véhicule), nos prestataires de paiement (pour le versement de vos revenus), les autorités compétentes (contrôles réglementaires, réquisitions judiciaires), nos sous-traitants techniques (hébergement, analytics). Nous ne vendons jamais vos données. Vos documents professionnels ne sont jamais partagés avec les passagers.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">7. Conservation des données</h2>
          <p className="legal-section-text">
            Vos données sont conservées : pendant toute la durée de votre partenariat, 5 ans après la fin du partenariat pour les données de facturation, 1 an pour les données de géolocalisation, jusqu'à expiration + 1 an pour les documents professionnels. À l'issue de ces délais, vos données sont supprimées ou anonymisées.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">8. Sécurité</h2>
          <p className="legal-section-text">
            Nous protégeons vos données par : le chiffrement des données sensibles, l'authentification forte pour l'accès à votre compte, la restriction des accès selon le principe du besoin d'en connaître, des audits de sécurité réguliers, la formation de nos équipes. En cas de violation de données vous concernant, nous vous en informerons dans les meilleurs délais.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">9. Vos droits</h2>
          <p className="legal-section-text">
            Conformément au RGPD, vous disposez des droits suivants : accès à l'ensemble de vos données, rectification des données inexactes, effacement (sous réserve des obligations légales de conservation), limitation du traitement, portabilité de vos données, opposition au traitement pour motif légitime. Pour exercer ces droits, contactez dpo@rideluv.com. Vous pouvez introduire une réclamation auprès de la CNIL.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">10. Évaluations et notations</h2>
          <p className="legal-section-text">
            Les passagers peuvent vous attribuer une note après chaque course. Cette note est utilisée pour assurer la qualité du service. Vous pouvez consulter vos évaluations dans l'Application Pro. En cas de note injustifiée, vous pouvez la contester en contactant le support.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">11. Transferts internationaux</h2>
          <p className="legal-section-text">
            Vos données sont hébergées dans l'Union Européenne. En cas de transfert hors UE, des garanties appropriées (clauses contractuelles types, décision d'adéquation) sont mises en place conformément au RGPD.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">12. Modifications</h2>
          <p className="legal-section-text">
            Cette politique peut être mise à jour. Nous vous informerons de tout changement significatif par notification dans l'Application Pro ou par email. La date de dernière mise à jour est indiquée en haut de ce document.
          </p>
        </section>
      </main>

      <footer className="legal-footer">
        <p className="legal-footer-text">
          Une question sur vos données ? Contactez le DPO à <a href="mailto:dpo@rideluv.com" className="legal-footer-link">dpo@rideluv.com</a>
        </p>
      </footer>
    </div>
  );
}

export default PrivacyPro;
